import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { invalidateAiListeningProfileData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'
import {
  BrandProfile,
  CompetitorInput,
} from 'src/services/aiListeningApi/brandProfile.types'

interface CreateVariables {
  payload: CompetitorInput
  profileId: string
}

interface UseCreateAiListeningCompetitorMutationParams {
  onError?: (error: AxiosError<AiListeningErrorEnvelope>) => void
  onSuccess?: (competitor: BrandProfile) => void
}

export const useCreateAiListeningCompetitorMutation = ({
  onError,
  onSuccess,
}: UseCreateAiListeningCompetitorMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ payload, profileId }: CreateVariables) =>
      AiListeningBrandProfileApiService.createCompetitor(profileId, payload),
    onError,
    onSuccess: (competitor) => {
      invalidateAiListeningProfileData(queryClient)
      onSuccess?.(competitor)
    },
  })
}
